import * as React from 'react';
import {classNames} from '@shopify/react-utilities/styles';
import {Link, Text} from 'components/UIKit';
import {FooterLink} from '../../types';
import style from '../../Footer.scss';

interface FooterListProps {
  label: string;
  links: FooterLink[];
  className?: string;
}

export function FooterList({label, links, className}: FooterListProps) {
  return (
    <div className={classNames(style.Section, className && className)}>
      <Text text={label} type="h5" component="h3" inheritColor />
      <ul className={style.List}>
        {links.map((link) => (
          <li className={style.ListItem} key={link.url}>
            <Link url={link.url} text={link.label} className={style.Link} resetMargin />
          </li>
        ))}
      </ul>
    </div>
  );
}
